import { InjectionToken } from '@angular/core';

import { DebugMessage } from '../models/debug-message';

export interface DebugWriter {
  write(msg: DebugMessage): void;
}

export const DEBUG_MESSAGE_CONSUMER = new InjectionToken<DebugWriter>('DEBUG_MESSAGE_CONSUMER');
